import { TranslationKey } from './../../../../types/translation/TranslationKey';

import React from 'react';
import { t } from '../../../../types/translation/Translator';
import { GlobeIcon } from '../../../icons/Globe/GlobeIcon';
import { Country } from '../../../../types/common/address';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { CountryFilterDropdownContent, CountryFilterInnerContent } from './DropdownContent';
import { itemsContainText } from '../../../../util/string.util';

export class CountryFilter extends BaseFilter<Country> {
  toLabel(): string {
    return t(TranslationKey.country).singular.label;
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <CountryFilterInnerContent filter={this} filterProps={props.filterProps} setFilterProps={props.setFilterProps} />
    );
  }

  toDropdownContent(props: BaseFilterProps): React.JSX.Element {
    return (
      <CountryFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  search(item: Country, query: string): boolean {
    return itemsContainText(query, [item.countryCode, item.countryName]);
  }

  toIcon(props: BaseFilterProps): React.JSX.Element {
    return <GlobeIcon className={this.className} />;
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.country?.size || 0;
  }
}
